import moneyFormat from '../functions/moneyFormat'; 
import decimalToPercent from '../functions/decimalToPercent'; 
import { TableCell } from '@mui/material';

const ConsortiumViewFooter = ({tableHeader, footerObj,stickyEnabled}) => {

        // const style = {backgroundColor: "#339378", color: "#ffffff !important", borderRight:"1px white solid",borderLeft:"1px white solid"}
    // const styleWithoutBorder = {backgroundColor: "#339378", color: "#ffffff !important"}

    const style = {backgroundColor: "#E6EDF1", color: "#000000 !important", borderRight:"1px white solid",borderLeft:"1px white solid"}
    const styleWithoutBorder = {backgroundColor: "#E6EDF1", color: "#000000 !important"}

    // old color: #E6EDF1

    const determineBorder = (val) => {
        if(typeof val === 'undefined' || typeof val === 'string'){
            return styleWithoutBorder
        }
        return style
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-footer": ""
    }


    return(
        <>
            {tableHeader.map( el => 
                el['columnname'] == 'cyclegrossspend' || el['columnname'] == 'cyclegrossinterchange'
                || el['columnname'] == 'ytdgrossspend' || el['columnname'] == 'ytdgrossinterchange' ? 
                    <TableCell className={getRowClassName(el['columnorder'])} align='right' sx={determineBorder(footerObj[el['columnname']])}>{moneyFormat(footerObj[el['columnname']])}</TableCell>
                : <TableCell className={getRowClassName(el['columnorder'])} sx={determineBorder(footerObj[el['columnname']])}>{footerObj[el['columnname']]}</TableCell>
            )} 
        </>
    ); 
}

export default ConsortiumViewFooter; 